import api from './client';

export const profileApi = {
  // Orders
  getOrders: () => api.get('/profile/orders'),
  getOrderDetail: (orderId) => api.get(`/profile/orders/${orderId}`),

  // Account
  getAccount: () => api.get('/profile/account'),
  updateAccount: (data) => api.put('/profile/account', data),
  changePassword: (currentPassword, newPassword) =>
    api.put('/profile/password', { current_password: currentPassword, new_password: newPassword }),
  deleteAccount: () => api.delete('/profile/account'),

  // Favorites
  getFavorites: () => api.get('/profile/favorites'),
  addFavorite: (productId) => api.post(`/profile/favorites/${productId}`),
  removeFavorite: (productId) => api.delete(`/profile/favorites/${productId}`),
  checkFavorite: (productId) => api.get(`/profile/favorites/check/${productId}`),
};
